<template>
  <div id="accessories" class="w-100 tc black pb4" >
    <div class="pa3-ns f1-ns f2 b pt4-ns pv3 tc ps-blue">Accessories to get the job done.</div>
    <div class="container w-100">

        <div class="w-25-ns w-80 ma3-ns box tc center" :class="[ mobile ? ' mv3' : 'dib']" >
          <img class="image" src="../assets/tools.jpg"/>
          <div class="f3 ph3-ns text">
            Tools & Accessories 
          </div>
          <div class="f5 tl pa2">
            We offer anything insulation and other tools to make your project more efficient. We carry fire rated tapes and adhesives as well as caucking and sealants.  Get the job done right with Prosource Supply.

          </div>
        </div>

        <div class="w-25-ns w-90 ma3-ns mh5-ns box tc center" :class="[ mobile ? ' mv3' : 'dib']" >
            <img class="image" src="../assets/hazmat.png"/>
          <div class="f3 ph3-ns text">
            Safety Suits & Protective Gear
          </div>
          <div class="f5 tl pa2">
            Safety is #1 at Prosource Supply! We carry all Personal Protection Equipment from hazmat suits to hard hats, Prosource Supply is a one stop shop for personal protection. Stay safe and keep your employees safe. 
          </div>
          
        </div>

        <div class="w-25-ns w-90 ma3-ns box tc center" :class="[ mobile ? ' mv3' : 'dib']" >
            <img class="image w-100" src="../assets/graco-machine.png"/>
          <div class="f3 ph3-ns text">
            Spray Foam Accessories        
          </div>
          <div class="f5 tl pa2">
            ProSource is a trusted supplier of Graco spray foam equipment, including spray guns, hoses, proportioners and more. Graco equipment is known as the best in the industry for its reliability, ease of use and performance.           </div>
        </div>

        <!-- <div class="w-25-ns w-90 ma3-ns box tc center" :class="[ mobile ? ' mv3' : 'dib']" >
            <img class="image w-100" src="https://uploads-ssl.webflow.com/5d235859488330e1ebfaae5c/5d56a0281dcc7b6d5ba97b3e_ducting-1.jpg"/>
          <div class="f3 ph3-ns text">
            HVAC Supplies        
          </div>
          <div class="f5 tl pa2">
            ProSource carries Quietflex HPDFlex, featuring a resilient metallic, polyester vapor barrier, and Johns Manville formaldehyde-free insulation for use in high pressure HVAC systems. 
          </div>
        </div> -->

    </div>
      <div class="w-20-ns tc w-70 mt4-ns mt2 center">
      <div class="f3-ns f4 pa1">
          <a class="link" :href="info.tel">
            <div class="contact-button ps-blue b br3 bg-yellow tc paa link"><i class="fa fa-phone mr3" style="font-size:20px"/>Call for a quote!<div class="">{{info.phone}}</div></div>
        </a> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accessories',
  props: ['info', 'mobile']
};
</script>

<style scoped>
.image {
  height: 370px;
  /* border-bottom: black 2px solid; */
}

.box {
  min-height: 460px;
  min-width: 340px;
  border: black 2px solid;  
}

.text {
  min-height: 70px;
  padding-top: 15px;
}

#accessories {
  min-height: 85vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
}
.contact-button {
  color: rgb(15,55,111) !important;
}

.contact-button:hover {
  background: rgb(15, 55, 111) !important;
  color: gold !important;
  box-shadow: gold 5px 5px !important;
  transition: .3s ease;
}

.contact-button {
  box-shadow: rgb(15,55,111) 5px 5px !important;
  background:gold 5px 5px !important;
  padding: .7rem !important;
  color: rgb(15, 55, 111) !important;
  transition: .3s ease;
}
</style>